import { createIcon } from '@chakra-ui/icon'

export const BillIcon = createIcon({
  displayName: 'BillIcon',
  viewBox: '0 0 48 48',
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M10 6a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v38l-7-5l-7 5l-7-5l-7 5zm8 16h12m-12 8h12M18 14h12"
    />
  ),
})
